export const WAREHOUSE_METRICS_GET = 'WAREHOUSE_METRICS_GET';
export const WAREHOUSE_METRICS_GET_SUCCESS = 'WAREHOUSE_METRICS_GET_SUCCESS';
export const WAREHOUSE_METRICS_GET_FAILURE = 'WAREHOUSE_METRICS_GET_FAILURE';
export const WAREHOUSE_METRICS_RESET = 'WAREHOUSE_METRICS_RESET';

export const PRODUCT_METRICS_GET = 'PRODUCT_METRICS_GET';
export const PRODUCT_METRICS_GET_SUCCESS = 'PRODUCT_METRICS_GET_SUCCESS';
export const PRODUCT_METRICS_GET_FAILURE = 'PRODUCT_METRICS_GET_FAILURE';
export const PRODUCT_METRICS_RESET = 'PRODUCT_METRICS_RESET';

export const PRODUCT_BY_GROUP_GET = 'PRODUCT_BY_GROUP_GET';
export const PRODUCT_BY_GROUP_GET_SUCCESS = 'PRODUCT_BY_GROUP_GET_SUCCESS'; 
export const PRODUCT_BY_GROUP_GET_FAILURE = 'PRODUCT_BY_GROUP_GET_FAILURE';
export const PRODUCT_BY_GROUP_RESET = 'PRODUCT_BY_GROUP_RESET';

export const LAGERKODE_GET = 'LAGERKODE_GET';
export const LAGERKODE_GET_SUCCESS = 'LAGERKODE_GET_SUCCESS';
export const LAGERKODE_GET_FAILURE = 'LAGERKODE_GET_FAILURE';
export const LAGERKODE_RESET = 'LAGERKODE_RESET';

